export default __webpack_public_path__ + "static/media/salary2.df83b399.png";